import type { FaireProductEntity } from "../../entity_types/product";

export const p_ez958e3g2u: FaireProductEntity = {
  token: "p_ez958e3g2u",
  type: "product",
  name: "Wild Flower Bath Fizz - Moisturizing Herbal Bath Soak",
  brandToken: "b_mh8t7w72tx",
  brandName: "Cedar Hill Homestead",
  imageUrl:
    "https://cdn.faire.com/fastly/16ff0663ab9c3d82611e5c715fb46723fc48ed41b17ee8981826c4ddaf9d3528.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b58c4b33053969f67e95bcd6c963c66badb2ee386ac19efbd40a94725c95b250.jpeg",
    "https://cdn.faire.com/fastly/d5e64e4eaefc12cb58b2d942790609f851b6db5105ffeb6fb57ad71ee9c123c5.jpeg",
    "https://cdn.faire.com/fastly/1e37a7bb269a381861110a42f3b130b0501b7204a32e4cbb88f695e16b8aa37a.jpeg",
    "https://cdn.faire.com/fastly/2f4ce608ce5c204501ff60358063bdc91da8481b3ccb201ee8cbffdbb54977d8.jpeg",
    "https://cdn.faire.com/fastly/f9a30f42c165db448ad03622a494728e2b99ef2086506258c78d1ac10f474d12.jpeg",
    "https://cdn.faire.com/fastly/7e909db0249d6892082f98d9506a49ab930c9fb1616d54edb374ceb57ca1e1e6.jpeg",
    "https://cdn.faire.com/fastly/c007ef4d2d56f2be055306e01d7d3da51c53587a6111c3faaa79127f387e1e46.jpeg",
    "https://cdn.faire.com/fastly/ae39e3e02883ded633c29c5dec2d06482588c254ae2f9a717ca19c88feffcbae.png",
    "https://cdn.faire.com/fastly/1983866963afc2806240d385920fd186e98ec2a6c7c50ca97b296fbc745d6efd.webp",
    "https://cdn.faire.com/fastly/a850b697f4294f6a2a0626a6e63045b1a59235933b1976941348799f031bbaf5.webp",
  ],
  priceDollars: 14,
  description:
    "It’s a bath bomb! It’s a bath salt! It’s a bath salt bomb fizz. It’s bath fizz! What makes it better than a bath salt you might ask? Well, it is a bath salt. But it fizzes pretty colors like a bath bomb. What makes it different than a bath bomb then? Well, it uses FAR less packaging materials, it won’t break in the mail, you get multiple uses instead of one and well… that’s it. Each bag is 8 oz and has 4-6 uses!\n\nWildwood Flower Bath Fizz:\nWildwood transports us to sunny days on a blanket of grass, bees covered in pollen from a flower nap and the sweet sound of hummingbirds hovering above a feeder. Homegrown Tennessee flowers and hemp leave skin soothed and supple.\n\nForest's Pull Bath Fizz:\nThe naturally camphorous oils found amongst the deep shades of evergreens will gently transport you to a place of peace and grounding. Ancient resins and saps mixed with full spectrum hemp melt away aches, pains, feverish skin and even congestion.",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:19.627Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
